// src/api/auth.js
import request from './request'
export default {
  login(data) { return request.post('/auth/login', data) },
  getMe() { return request.get('/auth/me') },
  changePassword(data) { return request.put('/auth/password', data) }
}
